import { render, staticRenderFns } from "./FichaMama.vue?vue&type=template&id=e1096852&"
import script from "./FichaMama.vue?vue&type=script&lang=js&"
export * from "./FichaMama.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports